import { l } from '@manychat/manyui'

import { ActionTypes } from 'common/actions'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { IActionGroupNode } from 'common/builder/nodes/nodeInterfaces'

export const getActionNodeNextStep = (node: IActionGroupNode) => {
  const hasDeleteSubscribersAction = node.items.some(
    (action) => action.type === ActionTypes.DELETE_SUBSCRIBER,
  )

  const nextStepBuilder = new FlowChartNextStepBuilder(node.id).withLabel(l.translate('Next Step'))

  if (hasDeleteSubscribersAction) {
    nextStepBuilder
      .withDisabled(true)
      .withTooltip(
        l.translate(
          'All data for contacts who reach this action step will be deleted. No other actions can be done after Delete Contact action.',
        ),
      )
  }

  return nextStepBuilder.build()
}
